var module = angular.module('octopusApp.users');

module.directive("authProvider", function () {
    return {
        restrict: 'E',
        templateUrl: 'areas/users/views/auth_provider.html',
        replace: true,
        transclude: true,
        controller: 'AuthProviderController',
        scope: {
            provider: '=',
            isSubmitting: '=',
            handleSignInError: '=',
            shouldAutoLogin: '='
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/users/directives/auth_provider.js
// module id = 645
// module chunks = 1